var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDydxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:url(#SVGID_00000000944575586617848830000002046620659706730150_);}\n\t.st3{fill:url(#SVGID_00000107560938853133787230000016327480055664546464_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 440.6078,
    x2: 881.2156,
    y2: 440.6078
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C2C3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A1A27"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M549.5,209.4L221.1,671.7h100.8L652,209.4H549.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122714667581155677090000015209799063586749351_",
    gradientUnits: "userSpaceOnUse",
    x1: 299.7324,
    y1: 636.0956,
    x2: 435.1919,
    y2: 469.6819,
    gradientTransform: "matrix(1 0 0 -1 0 882.236)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.55
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122714667581155677090000015209799063586749351_)"
    },
    d: "M332.4,209.4l96.6,136.2L378.6,420 L229.5,209.4H332.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097489938802511914580000009218156478859123864_",
    gradientUnits: "userSpaceOnUse",
    x1: 585.1372,
    y1: 247.5419,
    x2: 419.0098,
    y2: 475.4516,
    gradientTransform: "matrix(1 0 0 -1 0 882.236)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6966FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6966FF",
      stopOpacity: 0.36
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097489938802511914580000009218156478859123864_)"
    },
    d: "M559.3,671.8L452.2,521.1l50.4-72.2 l157.5,222.9H559.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDydxIcon);
export default __webpack_public_path__ + "static/media/dydx_icon.ae0aac4664f163573111bfe7bea48dfb.svg";
export { ForwardRef as ReactComponent };